// extracted by mini-css-extract-plugin
export default {"igaoRoot":"igaoRoot-b0a90452","mt":"mt-d1af52f6"};